<template>
  <div
    v-if="!!alert"
    class="alert"
    :class="`alert-${alert.type} text-${align}`"
    v-html="alert.message"
    role="alert"
  ></div>
</template>

<script>
export default {
  props: {
    alert: { type: Object }
  },
  computed: {
    align() {
      return this.alert.align || "center";
    }
  }
};
</script>
